import React from 'react';

import TitleBar from 'src/components/pages/pageElements/titleBar';
import { TURN_OFF_PEBBLES } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import PatientPebblesTable from 'src/pebbles/components/PatientPebblesTable';

interface PatientPebblesProps {
  patientId: string;
}

const PatientPebbles: React.FC<PatientPebblesProps> = ({ patientId }) => {
  const turnOffPebbles = useFeatureFlag(TURN_OFF_PEBBLES);
  return (
    <div data-testid="pebbles-table">
      <TitleBar title="Pebbles" />
      {!turnOffPebbles && <PatientPebblesTable patientId={patientId} />}
      {turnOffPebbles && <div>Pebbles are turned off</div>}
    </div>
  );
};

export default PatientPebbles;
